const getProgramReadableName = (programId, listOfPrograms) => {
  if (!programId || !listOfPrograms) return

  const appProgram = listOfPrograms.find(p => p.id === programId)
  return appProgram ? appProgram.name : null
}

module.exports = getProgramReadableName
